module.exports = __webpack_public_path__ + "static/media/中高天文部.0da9f03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中高天文部.png
// module id = 312
// module chunks = 10